import React from "react";

import { Button, Dialog, DialogActions, IconButton } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";

const DeleteModal = ({ open, handleClose, title, desc, handleSubmit }) => {
  return (
    <Dialog
      open={open}
      onClose={(_e, reason) =>
        reason === "backdropClick" ? "" : handleClose()
      }
      hideBackdrop
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-modal"
      sx={{
        ".MuiPaper-root": {
          width: "520px",
        },
      }}
    >
      <div className="modal-header">
        <h2 className="header-text">{title}</h2>
        <IconButton onClick={() => handleClose()}>
          <GridCloseIcon />
        </IconButton>
      </div>
      <p
        className="modal-desc"
        dangerouslySetInnerHTML={{
          __html: desc,
        }}
      ></p>

      <DialogActions>
        <div
          style={{ display: "flex", gap: "8px" }}
          className="modal-btn-container"
        >
          <Button onClick={handleSubmit} className="button-common delete-btn">
            Delete
          </Button>
          <Button onClick={handleClose} className="button-common light-blue-bg">
            Cancel
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteModal;
